import React, { useEffect } from "react";
import "./Blog.css";
import Fade from "react-reveal/Fade";
import { FaRocket, FaLightbulb, FaTools, FaBrain, FaGamepad, FaArrowLeft } from "react-icons/fa";

const Blog = ({ onBack }) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="blog-section" id="blog-detail">
            <div className="container">
                <button className="btn btn-secondary back-btn mb-4" onClick={onBack}>
                    <FaArrowLeft className="me-2" /> Back to Portfolio
                </button>
                <Fade bottom>
                    <div className="section-header text-center mb-5">
                        <img
                            src="kb-logo.png"
                            alt="Knowledge Bubble Logo"
                            className="kb-logo-animated mb-3"
                            style={{ width: '100px', height: '100px', objectFit: 'contain' }}
                        />
                        <h1 className="section-title">
                            My <span className="gradient-text">Blog</span>
                        </h1>
                        <p className="section-subtitle">Stories of growth, engineering, and leadership</p>
                    </div>
                </Fade>

                <div className="blog-post-card-container">
                    {/* Block 1: The Mission */}
                    <Fade bottom>
                        <div className="row g-5 align-items-center mb-5 pb-5">
                            <div className="col-lg-6">
                                <div className="blog-header mb-4" style={{ textAlign: 'left' }}>
                                    <span className="blog-category">The Beginning</span>
                                    <h2 className="blog-title">From Web Intern to Product Visionary</h2>
                                    <h3 className="blog-subtitle">The Story of Knowledge Bubble</h3>
                                </div>
                                <div className="blog-content">
                                    <p className="blog-intro">
                                        Every product has a story. This one began at Jabsz Studios, starting from zero with no roadmap and a small, dedicated team.
                                    </p>
                                    <p className="blog-highlight-box">
                                        Our goal was simple: <strong>Transform learning into a game.</strong>
                                    </p>
                                    <p>
                                        Starting with a basic quiz concept, we pushed the boundaries of React Native to create an immersive educational world.
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="project-image-wrapper">
                                    <img
                                        src="kb-preview.png"
                                        alt="Knowledge Bubble Preview"
                                        className="project-main-img"
                                    />
                                    <div className="project-image-border-glow"></div>
                                </div>
                            </div>
                        </div>
                    </Fade>

                    {/* Block 2: Technical Challenges */}
                    <Fade bottom>
                        <div className="row g-5 align-items-center mb-5 pb-5 flex-row-reverse">
                            <div className="col-lg-6">
                                <section className="blog-sub-section h-100 mb-0">
                                    <h4><FaTools className="me-2 icon-blue" /> 🛠️ The Technical Migration</h4>
                                    <p>
                                        As the app grew, so did our challenges. Migrating from <strong>Expo to Bare React Native</strong> was our boldest decision. 
                                    </p>
                                    <p>
                                        It meant dealing with native Android/iOS configurations, fixing crashes hands-on, and managing team chaos while the entire codebase was in flux.
                                    </p>
                                    <div className="blog-grid-highlights mt-4">
                                        <div className="grid-item"><span>🛠️</span> Codebase Repair</div>
                                        <div className="grid-item"><span>👥</span> Team Guidance</div>
                                    </div>
                                </section>
                            </div>
                            <div className="col-lg-6">
                                <div className="project-image-wrapper">
                                    <img
                                        src="knowledge-bubble.png"
                                        alt="Technical Roadmap"
                                        className="project-main-img"
                                    />
                                    <div className="project-image-border-glow"></div>
                                </div>
                            </div>
                        </div>
                    </Fade>

                    {/* Block 3: The Result - Version 2.0 */}
                    <Fade bottom>
                        <div className="row g-5 align-items-center mb-5 pb-5">
                            <div className="col-lg-6">
                                <section className="blog-sub-section h-100 mb-0">
                                    <h4><FaRocket className="me-2 icon-blue" /> 🚀 Knowledge Bubble 2.0</h4>
                                    <p>
                                        After months of engineering discipline, we launched Version 2.0. A platform built for scale, performance, and engaging gameplay.
                                    </p>
                                    <div className="feature-grid mb-4">
                                        <div className="feature-card-title">🎮 15+ Games</div>
                                        <div className="feature-card-title">🤝 Real-Time Multiplayer</div>
                                        <div className="feature-card-title">🏆 Leaderboards</div>
                                    </div>
                                    <p className="blog-alert-warning">
                                        This wasn't just a launch; it was proof that systematic problem-solving wins.
                                    </p>
                                </section>
                            </div>
                            <div className="col-lg-6">
                                <div className="project-image-wrapper">
                                    <img
                                        src="KB.png"
                                        alt="Product Launch"
                                        className="project-main-img"
                                    />
                                    <div className="project-image-border-glow"></div>
                                </div>
                            </div>
                        </div>
                    </Fade>

                    <Fade bottom>
                        <section className="blog-footer mt-5">
                            <h4 className="footer-title"><FaRocket className="me-2" /> The Journey Continues</h4>
                            <p>Knowledge Bubble represents growth, leadership, and relentless learning. 💡🚀</p>
                        </section>
                    </Fade>
                </div>
            </div>
        </div>
    );
};

export default Blog;
